// extracted by mini-css-extract-plugin
export default {"Title":"Collapse_Title__7M0jh"};